import type { SVGProps } from "react";

/** Same path as `HeartIcon` in `@au-schein-de/au-ui-library` (viewBox 0 0 17 16). */
const HEART_ICON_PATH =
	"M14.7608 8.15284L8.51083 14.3428L2.26083 8.15284C1.84858 7.75168 1.52387 7.26952 1.30712 6.7367C1.09037 6.20389 0.986298 5.63197 1.00144 5.05695C1.01659 4.48194 1.15063 3.91629 1.39513 3.39562C1.63962 2.87495 1.98928 2.41055 2.42207 2.03166C2.85486 1.65276 3.36142 1.36758 3.90984 1.19407C4.45826 1.02057 5.03667 0.962493 5.60864 1.02351C6.18061 1.08452 6.73375 1.2633 7.23323 1.54859C7.73271 1.83389 8.1677 2.21951 8.51083 2.68117C8.85544 2.22286 9.29094 1.84061 9.79008 1.55834C10.2892 1.27608 10.8412 1.09988 11.4116 1.04077C11.982 0.981665 12.5584 1.04092 13.1048 1.21483C13.6512 1.38874 14.1559 1.67357 14.5871 2.05148C15.0184 2.42938 15.367 2.89224 15.6112 3.41108C15.8553 3.92992 15.9898 4.49358 16.0061 5.06676C16.0224 5.63995 15.9202 6.21033 15.7059 6.74221C15.4917 7.2741 15.1699 7.75603 14.7608 8.15784";

/** Status badge path from `UserLoggedInIcon` in `@au-schein-de/au-ui-library`. */
const USER_LOGGED_IN_STATUS_BADGE_PATH =
	"M19.0001 14C21.7615 14 24.0001 16.2386 24.0001 19C24.0001 21.7614 21.7615 24 19.0001 24C16.2387 24 14.0001 21.7614 14.0001 19C14.0001 16.2386 16.2387 14 19.0001 14ZM21.4981 16.9395C21.1885 16.6644 20.7147 16.6924 20.4395 17.002L18.3331 19.3711L17.5606 18.502C17.2855 18.1924 16.8116 18.1644 16.502 18.4395C16.1925 18.7146 16.1645 19.1885 16.4395 19.498L17.7725 20.998C17.9148 21.158 18.1191 21.2499 18.3331 21.25C18.5472 21.25 18.7513 21.1581 18.8936 20.998L21.5606 17.998C21.8356 17.6885 21.8075 17.2146 21.4981 16.9395Z";

interface FavoritesLoggedInIconRawProps extends SVGProps<SVGSVGElement> {
	showStatusBadge?: boolean;
}

export function FavoritesLoggedInIconRaw({
	showStatusBadge = false,
	...props
}: FavoritesLoggedInIconRawProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<title>Favorites</title>
			<g transform="translate(3.5 4)">
				<path
					d={HEART_ICON_PATH}
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			{showStatusBadge ? (
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d={USER_LOGGED_IN_STATUS_BADGE_PATH}
					fill="currentColor"
				/>
			) : null}
		</svg>
	);
}
